import { memo } from 'react';
import { Box, Button } from '@amzn/awsui-components-core';
import { ContentNode } from '@amzn/awscat-pattern-library-service-model';

import ConfirmationModalView from '../v2-common/ConfirmationModalView';
import { useDeletePageButtonViewModel } from './DeletePageButtonViewModel';

interface DeletePageButtonProps {
  readonly currentPage: ContentNode;
  /** Plain-text title shown in the confirmation message. */
  readonly pageTitle: string;
}

const DeletePageButton = memo(function DeletePageButton({
  currentPage,
  pageTitle,
}: DeletePageButtonProps) {
  const vm = useDeletePageButtonViewModel(currentPage);

  return (
    <>
      <Button variant="icon" iconName="remove" ariaLabel="Delete page" onClick={vm.openModal} />
      {vm.isModalVisible && (
        <ConfirmationModalView
          header="Delete Page"
          body={<Box>Delete page &quot;{pageTitle}&quot;? This operation cannot be undone.</Box>}
          confirmLabel="Delete"
          isConfirming={vm.isDeleting}
          onDismiss={vm.dismissModal}
          onConfirm={vm.confirmDelete}
        />
      )}
    </>
  );
});

export default DeletePageButton;
